import { useEffect, useState } from 'react'
import useAxios from '../../hooks/useAxios'
import { PaginationResponseInterface } from '../../types/pagination'
import SelectSearchMultiple, { IOptionSelect } from '../SelectSearchMultiple'
import SelectSearch from '.'
import { IAddress } from '../../types/address'
import { IOrder } from '../../types/order'

interface Props {
  handleFilterChange?: (filter: any) => void
  selected?: string[]
  onSelect: (e: any) => void
  resetAutoComplete?: string
  label?: string
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  helperText?: string | any
  error?: boolean | any
  name?: string
  searchType?: string
}

const OrderSelectSearch = (props: Props) => {
  const {
    handleFilterChange,
    selected,
    onSelect,
    resetAutoComplete = '',
    label = 'ค้นหาคำสั่งซื้อจากชื่อหรือเบอร์โทรศัพท์',
    searchType = 'customer_name',
    ...rest
  } = props
  const [search, setSearch] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search)

  const { data, isLoading } = useAxios<PaginationResponseInterface<IOrder>>({
    method: 'GET',
    url: '/order',
    params: {
      page: 1,
      perPage: 15,
      search: debouncedSearch,
      searchType: searchType,
      startDate: '',
      endDate: '',
    },
  })

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
      setLoading(false)
    }, 1000)

    return () => {
      clearTimeout(handler)
      setLoading(false)
    }
  }, [search])

  const handleSearch = async (value: string) => {
    setSearch(value)
  }

  const currentLoadingState = loading || isLoading

  return (
    <>
      <SelectSearch<IOrder>
        {...rest}
        loading={currentLoadingState}
        resetAutoComplete={resetAutoComplete}
        label={`${label} ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
        onSelect={onSelect}
        search={search}
        onSearch={handleSearch}
        options={
          data?.records.map((order: IOrder) => ({
            label: `${order.recipient.name} โทร.${order.recipient.phone}`,
            value: order,
          })) || ([] as IOptionSelect<any>[])
        }
      />
    </>
  )
}

export default OrderSelectSearch
